/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UiText } from '../../ui-text/ui-text';
import { Requirements } from '../../../row';
import { Mixin } from '../../../mixins/Mixin';
import { Filterable } from '../../../mixins/Filterable';

@Component({
    selector: 'fe-text',
    template: require('./fe-text.html'),
    styles: [
        require('./fe-text.less')
    ],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: FeText, multi: true}
    ],
})

@Mixin([Filterable])
export class FeText extends UiText {
    @ViewChild(UiText) innerUiText: UiText;

    @Input() prefix: string;

    @Input()
    public set requirements(requirements: (Requirements|string)[]) {
        this._requirements = requirements;
    }

    public get requirements(): (Requirements|string)[] {
        return this._requirements;
    }

    private _requirements: (Requirements|string)[] = [];

    constructor(public elementRef: ElementRef) {
        super(elementRef);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/form-elements/fe-text/fe-text.ts